import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastComponent } from './toast.component';
import { ToastService } from './toast.service';

/**
 * App-wide toast host. Mount once, near the root of the app shell. Renders the
 * stack held by `ToastService` in a fixed, top-right column that layers above
 * modals.
 */
@Component({
  selector: 'app-toast-outlet',
  imports: [ToastComponent],
  templateUrl: './toast-outlet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastOutletComponent {
  protected readonly service = inject(ToastService);
  protected readonly toasts = this.service.toasts;
}
